import React, { useEffect } from 'react';
import {useBCMSModal, DisabledPrompt, BrandingStyle} from "bcms-react";
import { LayoutContainer, LeftColumnContainer, RightColumnContainer, TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemView, TableView, WidgetContainer, WidgetView } from 'components/shared';
import { UICheckbox } from 'components/ui';
import { SVGAsset } from 'res';
import "./styles.css";
import "./mobile.css";
import NoFilesToDisplayTableRow from '../NoFilesToDisplayTableRow';

/**
 * @function MobilePendingACHPassThruTable
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The mobile Pending ACH Pass Thru Table
 */

export default function MobilePendingACHPassThruTable(props){
  const { pending, passThruACHDetailsModalIsOpen, showFormattedContent, isAllCheckSelected } = props.data ?? {}
  const { onShowFormattedContent, onShowRawContent, onPassThruACHDetailOpenModalClick, 
    onPassThruACHDetailCloseModalClick, onSelectAllCheckmarksChange, onRowChecked } = props.actions ?? {};



  const modalData = {
    passThruACHDetailsModalIsOpen,
    showFormattedContent,
    onShowFormattedContent,
    onShowRawContent,
    onPassThruACHDetailCloseModalClick,
    onPassThruACHDetailOpenModalClick,
    onRowChecked
  }
  const hasPending = pending.length > 0;

  const pendingRows = pending.reduce((acc, item) => {
    acc.push(<MobilePendingACHPassThruItem key={ item.id } data={ item } modalData={modalData}/>);
    return acc;
  }, []);

  return(
  
        <TableView className="mobile-pending-ach-pass-thru-table">
          <thead>
            <tr className="table-column-container" >
              <th colSpan="4"><UICheckbox label="" value={isAllCheckSelected} onChange={onSelectAllCheckmarksChange} /></th>
            </tr>
          </thead>
          <TableBody>
            { hasPending && pendingRows }
            { !hasPending && <NoFilesToDisplayTableRow colSpan="6" /> }
          </TableBody>
        </TableView>

  );
}

/**
 * @function MobilePendingACHPassThruItem
 * @return {React.Component}
 * @exported false
 * @description The table item for the MobilePendingACHPassThruTable 
 */

function MobilePendingACHPassThruItem(props){
  const { open } = useBCMSModal();
    const modalData = props.modalData ?? {};
    const data = props.data ?? {};
    const { onPassThruACHDetailOpenModalClick, onRowChecked } = modalData ?? {};

    const numOfParticipants = data.participants ? data.participants.length : 0;

  return(
    <TableItemContainer>
      <TableItemView>
        <UICheckbox className="item-row-checkbox" label="" value={ data.isChecked}  onChange={ onRowChecked(data.id) }  />
      </TableItemView>
      <TableItemView className="data-column">
        <LayoutContainer>
          <LeftColumnContainer>
            <div className="table-item-title"><b>Created By:</b></div>
          </LeftColumnContainer>
          <RightColumnContainer>
            <div className="table-item-detail text-right"><p>{data.createdBy}</p></div>
          </RightColumnContainer>
        </LayoutContainer>
        <LayoutContainer>
          <LeftColumnContainer>
            <div className="table-item-title">Updated:</div>
          </LeftColumnContainer>
          <RightColumnContainer>
            <div className="table-item-detail text-right"><p>{data.createdDate.format()}</p></div>
          </RightColumnContainer>
        </LayoutContainer>
        <LayoutContainer>
          <LeftColumnContainer>
            <div className="table-item-title">Status:</div>
          </LeftColumnContainer>
          <RightColumnContainer>
            <div className="table-item-detail text-right"><p>Pending Approval(s): {numOfParticipants}</p></div>
          </RightColumnContainer>
        </LayoutContainer>
        <LayoutContainer>
          <LeftColumnContainer>
            <div className="table-item-title">File Name:</div>
          </LeftColumnContainer>
          <RightColumnContainer>
            <BrandingStyle style={{ "color": "links_abi22" }}  className="table-item-detail text-right link clickable" element={<div onClick={onPassThruACHDetailOpenModalClick}><p>{data.fileName}</p></div>} />
          </RightColumnContainer>
        </LayoutContainer>
        {/* Approval Required by System */}
        </TableItemView>
        <TableItemView>
          <LayoutContainer>
            <LeftColumnContainer>
              {/* <DisabledPrompt>
                <SVGAsset id="EditIcon" className="edit-icon clickable" />
              </DisabledPrompt> */}
            </LeftColumnContainer>
            <RightColumnContainer>
            <DisabledPrompt>
              <SVGAsset id="TrashcanXIcon" className="clickable"/>
            </DisabledPrompt>
            </RightColumnContainer>
          </LayoutContainer>
        </TableItemView>
    </TableItemContainer>
  );
}